import { render } from "./InitiateDepositMoney.vue?vue&type=template&id=c236b2ae"
import script from "./InitiateDepositMoney.vue?vue&type=script&lang=js"
export * from "./InitiateDepositMoney.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__